import React from "react";
import { Order } from "../types";
import { InfoRow, Badge } from "../styles";
import { Eye, X, MapPin } from "lucide-react";
import { format } from "date-fns";
import useConfig from "@hooks/useConfig";
import { createPortal } from "react-dom";
import OrderDetails from "../../orders/individual-order-details/order-details";

interface Props {
  order: Order;
}

const OrderInfo: React.FC<Props> = ({ order }) => {
  const { bucketUrl } = useConfig();
  const [showModal, setShowModal] = React.useState(false);

  const trackingId = order.trackingId || `ORD-${order.id}`;

  const renderModal = () => {
    if (!showModal) return null;
    return createPortal(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.8)",
          backdropFilter: "blur(5px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000000,
          padding: "20px",
        }}
        onClick={() => setShowModal(false)}
      >
        <div
          style={{
            background: "white",
            width: "95vw",
            maxWidth: "100%",
            maxHeight: "90vh",
            borderRadius: "20px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
            position: "relative",
            padding: "40px 20px 20px 20px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <X
            size={24}
            cursor="pointer"
            onClick={() => setShowModal(false)}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              zIndex: 10,
              color: "#666",
            }}
          />

          <div style={{ overflowY: "auto", flex: 1 }}>
            <OrderDetails id={String(order.id)} />
          </div>
        </div>
      </div>,
      document.body,
    );
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        style={{
          padding: "8px 16px",
          background: "rgba(255, 49, 53, 0.1)",
          color: "#ff3135",
          border: "1px solid rgba(255, 49, 53, 0.2)",
          borderRadius: "20px",
          fontSize: "13px",
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          transition: "all 0.2s",
          whiteSpace: "nowrap",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "rgba(255, 49, 53, 0.15)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "rgba(255, 49, 53, 0.1)")
        }
      >
        <Eye size={16} /> View Details
      </button>
      {renderModal()}
    </>
  );
};

export default OrderInfo;
